// Référence API Velo : https://www.wix.com/velo/reference/api-overview/introduction

// Laisser cet import TOUT EN HAUT
import wixStores from 'wix-stores';

// Associe chaque SKU à l'URL de sa fiche PDF
const PDF_BY_SKU = {
  'VMAX-D-15': 'https://d5f89151-7a5f-4566-8b9e-db72cfe8267c.usrfiles.com/ugd/d5f891_f02db7516e784fda9505ba0cf00b6294.pdf',
  'VMAX-D-20': 'https://d5f89151-7a5f-4566-8b9e-db72cfe8267c.usrfiles.com/ugd/d5f891_b80ff3b52a584bc38d8337a57f09c389.pdf',
  'VMAX-D-25': 'https://d5f89151-7a5f-4566-8b9e-db72cfe8267c.usrfiles.com/ugd/d5f891_8e4d69f9c14846a6a1178c381bfe39e5.pdf',
  'VMAX-D-30': 'https://d5f89151-7a5f-4566-8b9e-db72cfe8267c.usrfiles.com/ugd/d5f891_cd8e8c8c60f04015850a1a7f52753a1d.pdf',
  'VMAX-D-35': 'https://d5f89151-7a5f-4566-8b9e-db72cfe8267c.usrfiles.com/ugd/d5f891_1ab920207c0b42a28224e1e336d1197a.pdf',
  'VMAX-D-40': 'https://d5f89151-7a5f-4566-8b9e-db72cfe8267c.usrfiles.com/ugd/d5f891_1b9c3012d136467dbcc2586c4575fbed.pdf',
  'VMAX-D-45': 'https://d5f89151-7a5f-4566-8b9e-db72cfe8267c.usrfiles.com/ugd/d5f891_fddfcd34a4ae4dba9cb742dcf46cc44a.pdf',
  'VMAX-D-50-S' :'https://d5f89151-7a5f-4566-8b9e-db72cfe8267c.usrfiles.com/ugd/d5f891_1ca9417613e94bab803c25efe378c015.pdf',
  'VMAX-D-50-K':'https://d5f89151-7a5f-4566-8b9e-db72cfe8267c.usrfiles.com/ugd/d5f891_85e731f604bc46db896d6bfcd4fcdf2b.pdf',
  'VMAX-D-60': 'https://d5f89151-7a5f-4566-8b9e-db72cfe8267c.usrfiles.com/ugd/d5f891_d9468b3cbb9e43dbb780cc0a54d5175a.pdf',
  'VMAX-D-70': 'https://d5f89151-7a5f-4566-8b9e-db72cfe8267c.usrfiles.com/ugd/d5f891_63f51af93ae14ef3a2da806207bc8b7d.pdf',
  'VMAX-D-80': 'https://d5f89151-7a5f-4566-8b9e-db72cfe8267c.usrfiles.com/ugd/d5f891_540ac2df54a848dc874fa123567d75dd.pdf',
  'VMAX-D-100':'https://d5f89151-7a5f-4566-8b9e-db72cfe8267c.usrfiles.com/ugd/d5f891_7cdd7d8fa13f461294f034b09d805cb2.pdf',
  'VMAX-D-120':'https://d5f89151-7a5f-4566-8b9e-db72cfe8267c.usrfiles.com/ugd/d5f891_11b7adc825464f8db6fa8e2c3f4f168f.pdf',
  'VMAX-D-130':'https://d5f89151-7a5f-4566-8b9e-db72cfe8267c.usrfiles.com/ugd/d5f891_ead0d7d26a9340cfba27322a4b2d4009.pdf',
  'VMAX-D-150':'https://d5f89151-7a5f-4566-8b9e-db72cfe8267c.usrfiles.com/ugd/d5f891_cd78719dfa7748af805ffd8c9dc46729.pdf',
  'VMAX-D-160':'https://d5f89151-7a5f-4566-8b9e-db72cfe8267c.usrfiles.com/ugd/d5f891_4f58e5dec5df4817b1a12a5908f2d884.pdf',
  'VMAX-D-200':'https://d5f89151-7a5f-4566-8b9e-db72cfe8267c.usrfiles.com/ugd/d5f891_b61f276c480c470aa607772cc4b60e24.pdf',
  'VMAX-D-250':'https://d5f89151-7a5f-4566-8b9e-db72cfe8267c.usrfiles.com/ugd/d5f891_17c35fc4c4cd4988916a5c26d684f58c.pdf',
  'VMAX-D-300':'https://d5f89151-7a5f-4566-8b9e-db72cfe8267c.usrfiles.com/ugd/d5f891_e08732da66d6403f91a6698809def473.pdf'
  
};

$w.onReady(async function () {
  try {
    // Cache le bouton au chargement
    if ($w('#btnPdf').hide) $w('#btnPdf').hide();

    // Récupère le produit affiché + son SKU
    const product = await $w('#productPage1').getProduct();
    const sku = (product && product.sku) || '';

    const url = PDF_BY_SKU[sku];
    if (!url) { if ($w('#btnPdf').collapse) $w('#btnPdf').collapse(); return; }

    // Configure le bouton
    $w('#btnPdf').label = 'Fiche technique';
    $w('#btnPdf').link = url;
    $w('#btnPdf').target = '_blank';
    if ($w('#btnPdf').expand) $w('#btnPdf').expand();
    if ($w('#btnPdf').show) $w('#btnPdf').show();

  } catch (e) {
    console.error('Erreur PDF produit :', e);
    if ($w('#btnPdf').collapse) $w('#btnPdf').collapse();
  }
});












$w.onReady(function () {

	$w.onReady(function () {
  // Scroll vers la section devis au clic sur le bouton du haut
  $w('#btnDevis').onClick(() => {
    $w('#devisSection').scrollTo({ duration: 500 });
  });
});


// Écrivez votre code JavaScript ici en utilisant l'API du framework Velo

	// Affichez « Hello World » :
	// console.log("Hello world!");

	// Appelez des fonctions sur des éléments de la page. Par exemple :
	// $w("#button1").label = « Cliquez‑moi ! »;

	// Cliquez sur « Tester » ou accédez à l'aperçu de votre site pour exécuter votre code

});